import { useEffect, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import AdminShell from './components/AdminShell'
import LoginScreen from './components/LoginScreen'
import { clearToken, onTokenCleared, readToken, writeToken } from './lib/token'

/**
 * Auth gate. There is one shared token; a 401 anywhere throws it away (see lib/api) and lands the
 * user back here with an explanation.
 */
export default function App() {
  const client = useQueryClient()
  const [token, setToken] = useState<string | null>(() => readToken())
  const [message, setMessage] = useState<string | null>(null)

  useEffect(
    () =>
      onTokenCleared((reason) => {
        setToken(null)
        setMessage(reason === 'unauthorized' ? 'Token klopt niet' : null)
        // Nothing in the cache is readable without a token, and the next user may be someone else.
        client.clear()
      }),
    [client],
  )

  if (token === null) {
    return (
      <LoginScreen
        message={message}
        onSubmit={(value) => {
          writeToken(value)
          setMessage(null)
          setToken(value)
        }}
      />
    )
  }

  return <AdminShell onLogout={() => clearToken('logout')} />
}
